import { isServerSide } from "./common-util";

export const supportsWebShare = () => !isServerSide() && Boolean(navigator.share);
